import { api } from 'api';
import { all, call, put, SagaReturnType } from 'redux-saga/effects';
import { activityActions } from 'store/data/activity';
import { activityTypeActions } from 'store/data/activityType';
import { areaActions } from 'store/data/area';
import { branchActions } from 'store/data/branch';
import { distributionCenterActions } from 'store/data/distributionCenter';
import { employeeActions } from 'store/data/employee';
import { subZoneActions } from 'store/data/subZone';
import { unitOfMeasureActions } from 'store/data/unitOfMeasure';
import { zoneActions } from 'store/data/zone';

import { operationWrapper } from './operationWrapper';

// Fetches the tenant blob and fans out the org-hierarchy domains:
// branch, distributionCenter, area, zone, subZone, employee, activity, activityType, unitOfMeasure.
// No feature gate — tenant data is structural and always required.
export function* initializeTenant() {
  function* work(tenantId: string) {
    const {
      activityDomain,
      activityTypeDomain,
      areaDomain,
      branchDomain,
      distributionCenterDomain,
      employeeDomain,
      subZoneDomain,
      unitOfMeasureDomain,
      zoneDomain,
    }: SagaReturnType<typeof api.getTenant> = yield call(api.getTenant, {
      tenantId,
    });

    yield all([
      put(branchActions.setDomain(branchDomain)),
      put(distributionCenterActions.setDomain(distributionCenterDomain)),
      put(areaActions.setDomain(areaDomain)),
      put(employeeActions.setDomain(employeeDomain)),
      put(activityActions.setDomain(activityDomain)),
      put(activityTypeActions.setDomain(activityTypeDomain)),
      put(subZoneActions.setDomain(subZoneDomain)),
      put(zoneActions.setDomain(zoneDomain)),
      put(unitOfMeasureActions.setDomain(unitOfMeasureDomain)),
    ]);
  }

  yield call(operationWrapper, work, null);
}
